<div class="background-color">
  <p>home works!</p>
</div>
